<template>
    <el-dialog width="800px"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        @close="dialogCloseAction"
        :close-on-click-modal="config.CloseOnClickModal || false"
        :close-on-press-escape="config.CloseOnPressEscape || false">
        <template v-slot:title>
            <div class="column-config_title">
                {{dialogTitle}}
            </div>
        </template>
        <div class="otp-advance-multi-dialog-container">
            <div class="top-search-group">
                <el-form :inline="true" :model="searchObj">
                    <el-form-item>
                        <el-select v-model="searchObj.key" :popper-append-to-body="false" placeholder="请选择">
                            <el-option v-for="option in selectOptions"
                                :key="option.prop"
                                :label="option.value"
                                :value="option.prop"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model.trim="searchObj.keyword" clearable :placeholder="config.advancePlaceholder||'请输入'" @keyup.enter.native="search" @change="inputChange"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="reset">重置</el-button>
                    </el-form-item>
                    </el-form>
            </div>
            <!-- 历史记录 -->
            <div v-if="historyConfig" class="history-container">
                <history-record
                    ref="historyrRecordRef"
                    :config="historyConfig"
                    @select="onHistorySelect">
                </history-record>
            </div>

            <div class="center-container">
                <el-table
                    :data="tableData"
                    highlight-current-row
                    v-loading="loading"
                    height="300"
                    ref="listTable"
                    @row-click="rowClick"
                    @select="changeSelect"
                    @select-all="changeSelectAll"
                    @current-change="currentRowChange"
                    class="left-table">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        v-for="(column, index) in config.tableConfig"
                        :key="column.prop + index"
                        :prop="column.prop"
                        :label="column.value"
                        :width="column.width"
                        show-overflow-tooltip>
                        <template v-slot="{ row }">
                            <template v-if="column.type === 'select'">{{dictFormat(row[column.prop], column.optionsKey,column.options) }}</template>
                            <template v-else>{{row[column.prop]}}</template>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="right-checked-list">
                    <div class="checked-list-title">
                        <span class="checked-num">已选<i>&nbsp;{{checkedList.length}}&nbsp;</i>项</span>
                        <span class="clear-all" @click="clearAll(true)">清空</span>
                    </div>
                    <!-- 记录的位置 -->
                    <div class="checked-items">
                        <div v-for="(item, index) in checkedList" :key="index"
                            :draggable="draggable"
                            @dragstart="handleItemDragStart($event, item, index)"
                            @dragend="handleItemDragEnd($event)"
                            @dragenter="handleItemDragEnter($event, item, index)"
                        >
                            <div v-if="config.hideTooltip" class="checked-every">
                                <span class="text">
                                    <span v-if="draggable">{{index+1}}.</span>
                                    {{displayColName === '' ? Object.values(item)[0] : item[displayColName]}}
                                </span>
                                <span class="close" @click="clearOne(item, index)"><i class="el-icon-close" style="font-size: 12px;"></i></span>
                            </div>
                            <el-tooltip
                                v-else
                                effect="dark"
                                placement="left">
                                <div slot="content">
                                    <span v-for="(attrItem, attrIndex) in item" :key="attrIndex">
                                        {{attrItem}}<br/>
                                    </span>
                                </div>
                                <div class="checked-every">
                                    <span class="text">{{displayColName === '' ? Object.values(item)[0] : item[displayColName]}}</span>
                                    <span class="close" @click="clearOne(item, index)"><i class="el-icon-close" style="font-size: 12px;"></i></span>
                                </div>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div class="config-footer">
                <el-row>
                    <el-col :span="3" style="line-height:30px;">共&nbsp;&nbsp;{{pageTotal}}&nbsp;&nbsp;项</el-col>
                    <el-col :span="16">
                        <el-pagination
                            background
                            class="table-pagination"
                            layout="sizes, prev, pager, next"
                            :current-page.sync="page.pageNo"
                            :page-size="page.pageSize"
                            :total="pageTotal"
                            :page-sizes="config.pageSizes"
                            @current-change="currentChange"
                            @size-change="pageSizeChange">
                        </el-pagination>
                    </el-col>
                    <el-col :span="5" style="text-align: right;">
                        <el-button type="text" @click="closeDialog">取消</el-button>
                        <el-button type="primary" @click="confirm">确定</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import request from '@/utils/http';
import _ from 'lodash';
import HistoryRecord from '../otpAdvanceDialog/HistoryRecord/Index.vue';
import { makeHistoryConfig, HISTORY_TYPES } from '../otpAdvanceDialog/HistoryRecord/config';

export default {
    components: { HistoryRecord },
    props: {
        // 支持右侧拖动
        draggable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        selectOptions() { // 可选搜索项
            return this.config.advanceConfig || this.config.tableConfig;
        },
        dialogTitle() { // 弹窗标题
            return this.config.advanceLabel || this.config.name || this.config.label;
        }
    },
    data() {
        return {
            dragEl: null,
            dragElData: null,
            dialogVisible: false, // 弹窗显示开关
            loading: false, // 加载中显示
            defaultPageSizes: [10, 20, 30, 50], // 默认pagesizes
            page: {
                pageSize: 10, // 每页条数
                pageNo: 1 // 当前页码
            },
            pageTotal: 0, // 数据总记录数
            searchObj: {}, // 搜索配置
            tableData: [], // 表格数据列表
            config: {}, // 本地化配置
            checkedList: [], // 已选列表
            displayColName: '', // 确定显示在已选列表中的是哪一列的字段值
            historyConfig: null
        };
    },
    methods: {
        handleItemDragStart(ev, item, key) {
            this.dragElData = { item, key };
            this.dragEl = ev.target;
            this.dragEl.classList.add('draging');
        },
        handleItemDragEnd(ev) {
            if (ev.preventDefault) {
                ev.preventDefault();
            }
            this.dragEl.classList.remove('draging');
            this.dragEl = null;
            this.dragElData = null;
        },
        handleDragStart() {},
        handleDragEnd() {},
        handleItemDragEnter(ev, item, key) {
            if (item !== this.dragElData.item) {
                this.checkedList.splice(this.dragElData.key, 1);
                this.checkedList.splice(key, 0, this.dragElData.item);
                this.dragElData.key = key;
            }
        },
        /**
         * @description: 获取数据列表
         */
        async fetchData() {
            this.loading = true;
            const transitionKeyword = this.config.requestMethod === 'post' ? this.searchObj.keyword : encodeURIComponent(this.searchObj.keyword);
            const search = this.searchObj.keyword === '' ? {} : { [this.searchObj.key]: transitionKeyword };
            const params = { ...this.advanceCascade, ...this.page, ...search };
            const requestMethod = this.config.requestMethod;
            const selectorConfig = {
                method: requestMethod || 'get',
                url: `${this.prefix}${this.config.advanceUrl}`
            };
            if (requestMethod === 'post') {
                selectorConfig.data = params;
            } else {
                selectorConfig.params = params;
            };
            const res = await request(selectorConfig);
            if (res && res.code === '0') {
                if (res.data.totalPage !== 0 && this.page.pageNo > res.data.totalPage) {
                    this.page.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            } else {
                this.tableData = [];
            }
            this.tableSelect();
            this.loading = false;
        },
        /**
         * @description: 初始化显示弹窗
         * @param {boolean} status 打开弹窗还是关闭弹窗
         * @param {object} config 高级弹窗的配置项对象
         * @param {object} advanceCascade 级联参数（ 弹窗表格查询时候，添加查询参数）
         * @param {array} checkedList 设置选中数组
         * @return {null} 弹窗配置对象为空 或 设置status关闭弹窗，则停止执行下面操作
         */
        show(status = true, config, advanceCascade = {}, checkedList) {
            config.tableConfig.forEach((item) => {
                if (item.displayName) this.displayColName = item.prop;
            });
            config.pageSizes = _.isArray(config.pageSizes) ? config.pageSizes : this.defaultPageSizes;
            this.prefix = config.prefix || '/api-lcp-idms/';
            this.dialogVisible = status;
            if (status === false) return;
            if (!config) {
                this.$message.error('弹窗配置对象为空！');
                return;
            }
            this.config = config;
            this.$set(this.searchObj, 'key', this.selectOptions[0].prop);
            this.$set(this.searchObj, 'keyword', '');
            this.advanceCascade = advanceCascade;
            if (checkedList) this.checkedList = JSON.parse(JSON.stringify(checkedList));
            this.fetchData();
            this.historyConfig = makeHistoryConfig(this.config);
        },
        /**
         * @description: 判断表格的对象与选中列表对象是否相等
         * @param {array} array 需要操作比较的数组
         * @param {object} theItem 需要比较的单个数据项对象
         * @param {function} callback 判断完成后的回调函数
         */
        judgeEqual(array, theItem, callback) {
            array.some((item, index) => {
                // 过滤对象数据函数
                const itemArr = Object.entries(item).filter(arr => !(arr[1] && ['object', 'function'].includes(typeof arr[1])));
                const length = itemArr.length;
                let count = 0;
                for (const [key, value] of itemArr) {
                    if (theItem[key] === value) count++;
                }
                if (count === length) {
                    callback && typeof callback === 'function' && callback(item, index);
                    return true;
                }
            });
        },
        /**
         * @description: 对表格进行选择操作
         */
        tableSelect() {
            this.tableData.forEach((item) => {
                this.judgeEqual(this.checkedList, item, () => {
                    this.$nextTick(() => {
                        this.$refs.listTable.toggleRowSelection(item, true);
                    });
                });
            });
        },
        /**
         * @description: 单选操作
         * @param {array} data 当前选中的数据数组
         * @param {object} row 当前操作行对象
         */
        changeSelect(data, row) {
            const inOrDel = data.indexOf(row);
            if (inOrDel < 0) {
                this.judgeEqual(this.checkedList, row, (cItem, cIndex) => {
                    this.clearOne(cItem, cIndex);
                });
            } else {
                let flag = true;
                this.judgeEqual(this.checkedList, row, () => {
                    flag = false;
                });
                if (flag) this.checkedList.push(row);
            }
        },
        /**
         * @description: 全选操作
         * @param {array} data 当前选中的数据数组
         */
        changeSelectAll(data) {
            if (data.length > 0) {
                data.forEach((item) => {
                    this.changeSelect(data, item);
                });
            } else {
                this.tableData.forEach((item) => {
                    this.judgeEqual(this.checkedList, item, (cItem, cIndex) => {
                        this.clearOne(cItem, cIndex);
                    });
                });
            }
        },
        /**
         * @description: 清除所有已选（可供外部调用）
         * @param {boolean} clearTable 是否需要清除表格（只有内部调用时需要true）
         */
        clearAll(clearTable) {
            this.checkedList = [];
            if (clearTable) this.$refs.listTable.clearSelection();
        },
        /**
         * @description: 清除单个已选
         * @param {object} cItem 当前操作行对象
         * @param {number} cIndex 当前操作行索引
         */
        clearOne(cItem, cIndex) {
            this.checkedList.splice(cIndex, 1);
            const row = this.tableData.find((item, index) => {
                return Object.entries(cItem).every(([key, value]) => {
                    if (item[key] === value) return true;
                    return false;
                });
            });
            if (row) {
                this.$refs.listTable.toggleRowSelection(row, false);
            }
        },
        /**
         * @description: 点击行操作
         * @param {object} row 当前操作行对象
         */
        rowClick(row) {
            this.$refs.listTable.toggleRowSelection(row, true);
            this.changeSelect(this.tableData, row);
        },
        /**
         * @description: 页码变化
         * @param {number} val 页码数字
         */
        currentChange(val) {
            this.page.pageNo = val;
            this.fetchData();
        },
        /**
         * @description: 每页条数变化
         * @param {number} val 每页条数
         */
        pageSizeChange(val) {
            this.page.pageSize = val;
            this.fetchData();
        },
        /**
         * @description: 搜索按钮操作
         */
        search() {
            this.page.pageNo = 1;
            this.fetchData();
        },
        /**
         * @description: 重置按钮操作
         */
        reset() {
            this.searchObj.keyword = '';
            this.fetchData();
        },
        /**
         * @description: 表格当前行操作
         * @param {object} row 当前操作行对象
         */
        currentRowChange(row) {
            this.currentRow = row;
        },
        /**
         * @description: 确认按钮操作
         * @return {null} 没选中取消执行下面操作
         */
        confirm() {
            if (this.checkedList.length <= 0 && !this.config.allowEmpty) {
                this.$message.warning('没选中数据');
                return;
            }
            const maxNum = this.config.maxNum;
            if (maxNum && this.checkedList.length > maxNum) {
                this.$message.warning(`${this.config.name}最多选中${maxNum}条`);
                return;
            }
            this._emitResult();
        },
        /**
         * @description: 返回选中值
         * @return {null} 弹窗没定义cbParams，执行下面操作
         */
        _emitResult() {
            const data = [];
            if (!this.config.cbParams) {
                this.$message.error('弹窗没定义cbParams配置!');
                return;
            }
            const cloned = _.cloneDeep(this.checkedList || []);
            this.checkedList.forEach((checkedItem, index) => {
                data[index] = {};
                for (const item of this.config.cbParams) {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    data[index][destProp] = checkedItem[sourceProp];
                }
            });
            this.$emit('confirm', data, this.config);
            this.$emit('getCheckedList', JSON.parse(JSON.stringify(this.checkedList)), this.config);
            this.addHistory(cloned);
            this.closeDialog();
        },
        /**
         * @description: 关闭弹窗
         */
        closeDialog() {
            this.dialogCloseAction();
            this.dialogVisible = false;
        },
        inputChange(val) { },
        /**
         * @description: 页面关闭重置参数操作
         */
        dialogCloseAction() {
            this.checkedList = [];
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.pageTotal = 0;
            this.searchObj = {};
            this.tableData = [];
            if (this.$refs.historyrRecordRef) {
                this.$refs.historyrRecordRef.close();
            }
            this.$emit('close');
        },
        dictFormat(val, optionsKey, options) {
            if (optionsKey) {
                const keyMaps = _.get(this.optionsData, optionsKey);
                const optionsKeyValue = _.get(keyMaps, val, val);
                return optionsKeyValue;
            } else if (options) {
                return _.get(options, val, val);
            } else {
                return val;
            }
        },
        // 选择历史记录项
        onHistorySelect(tag) {
            let text = tag.tagName;
            // 多个选项时，判断使用名称还是编码
            if (this.selectOptions && this.selectOptions.length > 1) {
                const optionRow = this.selectOptions.find(item => item.prop === this.searchObj.key);
                if (optionRow && optionRow.value && optionRow.value.endsWith('编码')) {
                    // 客户和供应商才使用编码
                    if ([HISTORY_TYPES.customer, HISTORY_TYPES.carrier].includes(this.historyConfig.type)) {
                        text = tag.tagCode;
                    }
                }
            }
            this.searchObj.keyword = text || tag.tagName;
            this.search();
        },
        // 添加历史记录
        addHistory(list) {
            const historyRef = this.$refs.historyrRecordRef;
            if (historyRef) {
                const filterd = [].concat(list).filter(Boolean);
                historyRef.addList(filterd);
            }
        }

    }
};

</script>

<style lang="less">
.column-config_title{
    small{
        margin-left: 25px;
    }
}
.otp-advance-multi-dialog-container {
    .top-search-group {
        .el-form-item {
            margin-bottom: 0px;
        }
    }
    .history-container {
        margin-top: 6px;
    }
    .center-container{
        width: 100%;
        height: 300px;
        margin-top: 22px;
        .left-table {
            width: 550px;
            float: left;
        }
        .right-checked-list {
            width: 200px;
            margin: 0 0 0 10px;
            height: 100%;
            float: left;
            box-sizing: border-box;
            .checked-num i {
                font-style: normal;
                color: #3EA4EB;
            }
            .clear-all {
                float: right;
                cursor: pointer;
            }
            .checked-list-title {
                width: 100%;
                height: 38px;
                background-color: #F2F2F2;
                line-height: 38px;
                color: #666666;
                padding: 0 10px 0 20px;
                box-sizing: border-box;
            }
            .checked-items {
                width: 100%;
                overflow: auto;
                height: 262px;
            }
            .checked-every {
                width: 100%;
                height: 38px;
                line-height: 38px;
                color: #666666;
                padding: 0 10px 0 20px;
                box-sizing: border-box;
                &:hover {
                    background-color: #F0F8FA;
                }
                .text {
                    width: 145px;
                    float: left;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
                .close {
                    float: right;
                    cursor: pointer;
                    color: #AAAAAA;
                    font-size: 18px;
                }
            }
        }
        &:after {
            clear: both;
        }
    }
    .config-footer {
        margin-top: 18px;
    }
    .table-pagination{
        float: right;
        padding: 0;
        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }
        .el-pager li:not(.disabled).active{
            border: 1px solid #00BCBF;
        }
    }
    .el-pagination.is-background{
        .btn-prev, .btn-next, .el-pager li{
            background-color: #ffffff;
            border: 1px solid #cccccc;
            border-radius: 4px;
        }
    }
}
</style>
